import React from 'react';

export function DatasourcesIcon({
  w = 18,
  h = 18,
  color = 'currentColor',
  disabled = false
}: {
  w?: number;
  h?: number;
  color?: string;
  disabled?: boolean;
}) {
  return (
    <svg
      width={w}
      height={h}
      opacity={disabled ? 0.5 : 1}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2_9275)">
        <path
          d="M1.875 4.5C1.875 3.34467 1.875 2.767 2.13505 2.34265C2.28055 2.1052 2.4802 1.90555 2.71765 1.76005C3.142 1.5 3.71967 1.5 4.875 1.5C6.03033 1.5 6.60799 1.5 7.03235 1.76005C7.2698 1.90555 7.46945 2.1052 7.61498 2.34265C7.875 2.767 7.875 3.34467 7.875 4.5C7.875 5.65533 7.875 6.23299 7.61498 6.65735C7.46945 6.8948 7.2698 7.09444 7.03235 7.23995C6.60799 7.5 6.03033 7.5 4.875 7.5C3.71967 7.5 3.142 7.5 2.71765 7.23995C2.4802 7.09444 2.28055 6.8948 2.13505 6.65735C1.875 6.23299 1.875 5.65533 1.875 4.5Z"
          stroke={color}
          strokeWidth="1.125"
        />
        <path
          d="M2.83625 11.0863C3.62139 10.3011 4.01396 9.90853 4.47908 9.79686C4.73933 9.73438 5.01068 9.73438 5.27093 9.79686C5.73604 9.90853 6.12861 10.3011 6.91376 11.0863C7.6989 11.8714 8.09145 12.2639 8.20313 12.7291C8.2656 12.9893 8.2656 13.2607 8.20313 13.5209C8.09145 13.9861 7.6989 14.3786 6.91376 15.1637C6.12861 15.9489 5.73604 16.3414 5.27093 16.4531C5.01068 16.5156 4.73933 16.5156 4.47908 16.4531C4.01396 16.3414 3.62139 15.9489 2.83625 15.1637C2.0511 14.3786 1.65853 13.9861 1.54686 13.5209C1.48438 13.2607 1.48438 12.9893 1.54686 12.7291C1.65853 12.2639 2.0511 11.8714 2.83625 11.0863Z"
          stroke={color}
          strokeWidth="1.125"
        />
        <path
          d="M10.5 13.5C10.5 12.3447 10.5 11.767 10.76 11.3426C10.9055 11.1052 11.1052 10.9055 11.3426 10.76C11.767 10.5 12.3447 10.5 13.5 10.5C14.6553 10.5 15.233 10.5 15.6574 10.76C15.8948 10.9055 16.0945 11.1052 16.24 11.3426C16.5 11.767 16.5 12.3447 16.5 13.5C16.5 14.6553 16.5 15.233 16.24 15.6574C16.0945 15.8948 15.8948 16.0945 15.6574 16.24C15.233 16.5 14.6553 16.5 13.5 16.5C12.3447 16.5 11.767 16.5 11.3426 16.24C11.1052 16.0945 10.9055 15.8948 10.76 15.6574C10.5 15.233 10.5 14.6553 10.5 13.5Z"
          stroke={color}
          strokeWidth="1.125"
        />
        <path
          d="M13.5 1.5V7.5M16.5 4.5H10.5"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_9275">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
